import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { api } from '@/redux/api';
import { useFacilityId } from './use-facilityid';

/**
 * 判断当前登录用户是否是认证任务的接收者（assigned_to）
 * @returns {Object} { isAssignTo: boolean, loading: boolean, taskInfo: Object|null }
 */
export const useIsAssignTo = () => {
    const [isAssignTo, setIsAssignTo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [taskInfo, setTaskInfo] = useState(null);

    // 获取当前设施ID
    const facilityId = useFacilityId();
    
    // 从Redux获取当前登录用户信息
    const currentUserId = useSelector(state => state.Auth.userId);
    
    useEffect(() => {
        // 如果没有facilityId或当前用户ID，则不执行查询
        if (!facilityId || !currentUserId) {
            setIsAssignTo(false);
            setLoading(false);
            setTaskInfo(null);
            return;
        }

        const checkIsAssignTo = async () => {
            setLoading(true);

            try {
                // 使用新接口：获取设施任务情况
                const facilityTaskData = await api.getFacilityTask(facilityId);
                
                if (!facilityTaskData || !facilityTaskData.task) {
                    // 没有找到认证任务
                    setIsAssignTo(false);
                    setTaskInfo(null);
                    return;
                }

                const task = facilityTaskData.task;
                setTaskInfo(task);

                // 判断当前用户是否是任务接收者（assigned_to）
                const isCurrentUserAssignTo = task.assigned_to === currentUserId;
                setIsAssignTo(isCurrentUserAssignTo);

            } catch (err) {
                console.error('Error checking assign to status:', err);
                setIsAssignTo(false);
                setTaskInfo(null);
            } finally {
                setLoading(false);
            }
        };

        checkIsAssignTo();
    }, [facilityId, currentUserId]);

    return {
        isAssignTo,
        loading,
        taskInfo
    };
};

